import React from 'react';
import PropTypes from 'prop-types';
import { PropTypesMeta } from '@zedoc/react-questionnaire';
import FormItem from '../FormItem';

const getHelpText = (touched, submitFailed, error, formulaError) => {
  if ((touched || submitFailed) && error) {
    return error;
  }
  if (formulaError) {
    return `[#ERR] ${formulaError.message}`;
  }
  return null;
};

const getValidateStatus = (
  touched,
  submitFailed,
  error,
  formulaError,
  required,
) => {
  if ((touched || submitFailed) && error) {
    return 'danger';
  }
  if (!error && required) {
    return 'success';
  }
  if (formulaError) {
    return 'warning';
  }
  return 'default';
};

const FormFieldWrapper = ({
  'data-testid': testId,
  htmlFor,
  label,
  labelExtra,
  required,
  meta: { touched, error, formulaError, submitFailed },
  extra,
  tooltip,
  colon,
  size,
  children,
  isFullHeight,
  disabled,
}) => {
  return (
    <FormItem
      data-testid={testId}
      htmlFor={htmlFor}
      label={label}
      labelExtra={labelExtra}
      required={required}
      validateStatus={getValidateStatus(
        touched,
        submitFailed,
        error,
        formulaError,
        required,
      )}
      help={getHelpText(touched, submitFailed, error, formulaError)}
      extra={extra}
      tooltip={tooltip}
      colon={colon}
      size={size}
      isFullHeight={isFullHeight}
      disabled={disabled}
    >
      {children}
    </FormItem>
  );
};

FormFieldWrapper.propTypes = {
  'data-testid': PropTypes.string,
  meta: PropTypesMeta,
  htmlFor: PropTypes.string,
  label: PropTypes.node,
  labelExtra: PropTypes.node,
  required: PropTypes.bool,
  children: PropTypes.node,
  extra: PropTypes.node,
  tooltip: PropTypes.string,
  colon: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'default', 'large']),
  isFullHeight: PropTypes.bool,
  disabled: PropTypes.bool,
};

FormFieldWrapper.defaultProps = {
  'data-testid': 'form-field-wrapper',
  meta: {},
  htmlFor: null,
  label: null,
  labelExtra: null,
  required: false,
  disabled: false,
  children: null,
  extra: null,
  tooltip: null,
  colon: false,
  size: 'default',
  isFullHeight: false,
};

export default FormFieldWrapper;
